<template>
  <div id="sdk2">
    <Menu></Menu>
    <div class="trial">
      <img class="icon" src="@/assets/contact/icon_Success.png" alt="" />
      <div class="tip1">提交成功</div>
      <div class="tip2">如需体验Desktron云桌面，您可以微信扫码添加客户经理</div>
      <div class="img">
        <img v-if="qrcode" class="qrcodeimg" :src="qrcode" alt="" />
      </div>
      <!-- <el-button class="btn" type="primary" @click="onSubmit"
        >立即试用</el-button
      > -->
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
export default {
  components: {
    Menu,
    Footer,
  },
  data() {
    return {
      qrcode: "",
    };
  },
  mounted() {
    setTimeout(() => {
      window.wlQrcodeCustomComp.getQrCodeUrl(
        {
          wl_qrcode_id: "1691751470912856064",
        },
        (data) => {
          this.qrcode = data.data.qr_code;
        }
      );
    }, 500);
  },
  methods: {
    // onSubmit() {
    //   window.open("https://console.todesk.com/#/register");
    // },
  },
};
</script>

<style lang="less" scoped>
.trial {
  margin-top: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .icon {
    width: 48px;
    margin-bottom: 28px;
  }
  .tip1 {
    font-size: 20px;
    color: #000;
    margin-bottom: 15px;
  }
  .tip2 {
    font-size: 12px;
    color: #9e9e9e;
    margin-bottom: 20px;
  }
  .img {
    width: 50%;
    min-height: 100px;
    margin-bottom: 38px;
  }
  .qrcodeimg {
    width: 100%;
  }
  .btn {
    width: 50%;
    background: #216ed8;
    margin-bottom: 50px;
    &:hover {
      background-color: #0b80fe;
    }
  }
}
</style>
